import {createContext, useEffect, useState} from "react";
import HttpRequest from "../Http/HttpRequest";
import {Loading} from "../Component/Loading/Loading";
import Notify from "../Notify/Notify";

export const CustomThemeContext = createContext(null);

export const CustomThemeLoad = ({children}) => {

    const [customSiteTheme, setCustomSiteTheme] = useState(null);

    useEffect(() => {

        HttpRequest.get(process.env.REACT_APP_NODE_SERVICE + 'site/site-theme')
            .then(x => setCustomSiteTheme({theme:x}))
            .catch((e) => {
                Notify.warning('Não autorizado', e)
                /*   setTimeout(() => {
                     window.location = '/#/accounts';
                   }, 500)*/
            });

    }, []);

    return <CustomThemeContext.Provider value={customSiteTheme}>
        <Loading isLoading={!customSiteTheme}>
            {customSiteTheme && children}
        </Loading>
    </CustomThemeContext.Provider>
}

